import { render, staticRenderFns } from "./TheBarcodeScanner.vue?vue&type=template&id=4b063784&scoped=true"
import script from "./TheBarcodeScanner.vue?vue&type=script&lang=js"
export * from "./TheBarcodeScanner.vue?vue&type=script&lang=js"
import style0 from "./TheBarcodeScanner.vue?vue&type=style&index=0&id=4b063784&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b063784",
  null
  
)

export default component.exports